import React from 'react';
import marcaDalan from './venta-especial-assets/marcas/dalan.png';
import marcaOki from './venta-especial-assets/marcas/oki.png';
import marcaVale from './venta-especial-assets/marcas/vale.png';
import marcaAdi from './venta-especial-assets/marcas/adi.png';
import marcaPremio from './venta-especial-assets/marcas/premio.png';
import marcaDiva from './venta-especial-assets/marcas/diva.png';
import marcaFresca from './venta-especial-assets/marcas/fresca.png';
import marcaTisuf from './venta-especial-assets/marcas/tisuf.png';
import marcaCovex from './venta-especial-assets/marcas/covex.png';

// Marcas reconocidas en el titulo de una publicacion.
// `soloMayusculas`: la palabra tambien existe en espanol comun (vale, premio,
// diva, fresca), asi que solo cuenta como marca si viene en mayusculas (VALE).
const MARCAS = [
    { nombre: 'Dalan', logo: marcaDalan },
    { nombre: 'Oki', logo: marcaOki },
    { nombre: 'Adi', logo: marcaAdi },
    { nombre: 'Tisuf', logo: marcaTisuf },
    { nombre: 'Covex', logo: marcaCovex },
    { nombre: 'Vale', logo: marcaVale, soloMayusculas: true },
    { nombre: 'Premio', logo: marcaPremio, soloMayusculas: true },
    { nombre: 'Diva', logo: marcaDiva, soloMayusculas: true },
    { nombre: 'Fresca', logo: marcaFresca, soloMayusculas: true },
];

const PATRON = new RegExp(`\\b(${MARCAS.map((m) => m.nombre).join('|')})\\b`, 'gi');

const buscarMarca = (palabra) => {
    const marca = MARCAS.find((m) => m.nombre.toLowerCase() === palabra.toLowerCase());
    if (!marca) return null;
    if (marca.soloMayusculas && palabra !== palabra.toUpperCase()) return null;
    return marca;
};

/**
 * Renderiza un titulo y reemplaza cada mencion reconocida de una marca (Oki,
 * Dalan, Vale...) por su logo; la palabra queda como alt. Si no hay marcas, es
 * texto plano.
 */
const TituloConMarcas = ({ titulo, className = '' }) => {
    if (!titulo) return null;

    const partes = [];
    let ultimo = 0;
    PATRON.lastIndex = 0;
    let match;

    while ((match = PATRON.exec(titulo)) !== null) {
        const marca = buscarMarca(match[0]);
        if (!marca) continue;
        if (match.index > ultimo) partes.push(titulo.slice(ultimo, match.index));
        partes.push({ texto: match[0], marca });
        ultimo = match.index + match[0].length;
    }
    if (ultimo < titulo.length) partes.push(titulo.slice(ultimo));

    if (!partes.some((p) => typeof p === 'object')) {
        return <span className={className}>{titulo}</span>;
    }

    return (
        <span className={className}>
            {partes.map((parte, i) =>
                typeof parte === 'string' ? (
                    <React.Fragment key={i}>{parte}</React.Fragment>
                ) : (
                    <img
                        key={i}
                        src={parte.marca.logo}
                        alt={parte.texto}
                        className="inline-block h-[1.5em] w-auto align-[-0.35em] select-none"
                        draggable="false"
                    />
                )
            )}
        </span>
    );
};

export default TituloConMarcas;
